'use es6';

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useReportingIncreaseCount } from 'dashboard-components/context/use-reporting-increase-count';
import { selectHasReportsPaidAccessScope } from 'dashboard-lib/public/userInfo/scopes';
import { useHistory } from 'react-router-dom';
import { getRouteName } from '../lib/routerUtils';
import { getPathname } from '../lib/historyUtils';
import { setProperties, track, EVENTS, trackBeforeUnload } from 'dashboard-ui-components/tracking/DashboardUITracker';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const trackPageExit = () => {
  trackBeforeUnload(EVENTS.exitPage);
};
export const Tracker = ({
  children
}) => {
  const history = useHistory();
  const hasReportingAddon = useSelector(selectHasReportsPaidAccessScope);
  const reportingIncreaseCount = useReportingIncreaseCount();
  setProperties({
    hasReportingAddon,
    reportingIncreaseCount
  });
  useEffect(() => {
    window.addEventListener('pagehide', trackPageExit);
    return () => {
      window.removeEventListener('pagehide', trackPageExit);
    };
  }, []);
  useEffect(() => {
    const routeName = getRouteName(getPathname(history));
    if (routeName) {
      track(EVENTS.pageView, {
        screen: routeName
      });
    }
  }, [history]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
Tracker.propTypes = {
  children: PropTypes.node.isRequired
};